/* eslint-disable */
import { notificationServices } from '@/Services';
import multipleConfigPo from '../multiplePoConfig';

export const openConfirmation = ({
    state,
    lists = {},
    tableData,
    setConfirmationModal,
    handleConfirmSave = () => { },
    message = '',
    heading = '',
    handleCloseConfirmation = () => { },
}) => {
    const errors = multipleConfigPo?.validator(
        state,
        lists?.processList,
        lists?.shifts,
        tableData
    );
    if (errors && Object.keys(errors).length > 0) {
        for (const key of Object.keys(errors)) {
            notificationServices.generateNotification({
                type: 'error',
                message: `${errors[key]?.itemName} in ${errors[key]?.storeName} - ${errors[key]?.message}`,
            });
            return;
        }
    }
    const redRows = tableData.rows.filter((row) => row._isNotFound);
    if (redRows.length > 0) {
        notificationServices.generateNotification({
            type: 'warning',
            message: `Cannot submit data. Please select products for ${redRows.length} red-highlighted items.`,
        });
        return;
    }

    setConfirmationModal({
        isOpen: true,
        heading: heading,
        message: message,
        handleCloseConfirmation: handleCloseConfirmation,
        handleConfirmSave: handleConfirmSave,
    });
};

export const openConfirmationDataEntry = ({
    state,
    lists = {},
    tableData,
    setConfirmationModal,
    handleConfirmSave = () => { },
    message = '',
    heading = '',
    handleCloseConfirmation = () => { },
}) => {
    // State validation - check required fields
    const requiredFields = [
        { key: 'fromStore', label: 'Store' },
        { key: 'internalProcess', label: 'Process' },
        { key: 'internalShift', label: 'Shift' },
        { key: 'poCreationDate', label: 'PO Creation Date' },
    ];

    const missingFields = requiredFields.filter((field) => {
        const value = state?.[field.key];
        return value === null || value === undefined || value === '';
    });

    if (missingFields.length > 0) {
        notificationServices.generateNotification({
            type: 'warning',
            message: `Please fill required fields: ${missingFields.map((f) => f.label).join(', ')}`,
        });
        return;
    }

    // Check for red highlighted rows (not found items)
    const redRows = tableData.rows.filter((row) => row._isNotFound);
    if (redRows.length > 0) {
        notificationServices.generateNotification({
            type: 'warning',
            message: `Cannot submit data. Please select products for ${redRows.length} red-highlighted items.`,
        });
        return;
    }
    const getErrors = () => {
        const errors = {};
        if (tableData?.rows && tableData?.headers) {
            const storeHeaders = tableData.headers.filter(header => header?.id !== 'Item Name' && header?.id !== 'SkuCode' && header?.id !== 'Total' && header?.id !== 'S.No' && header?.id !== 'Actions');

            tableData?.rows?.forEach((row, rowIndex) => {
                const itemName = row?.['Item Name'];
                storeHeaders.forEach(store => {
                    const storeData = row?.[store?.id];
                    if (storeData && !storeData?.noOrder && (storeData.qty === '' || storeData.qty === null || storeData.qty === undefined)) {
                        errors[`${itemName}_${store?.id}`] = {
                            message: 'Please enter quantity',
                            rowIndex: rowIndex,
                            storeName: store?.name,
                            itemName: itemName,
                        };
                    }
                });
            });
        }
        return errors;
    }
    const errors = getErrors();
    if (Object.keys(errors).length > 0) {
        for (const key of Object.keys(errors)) {
            notificationServices.generateNotification({
                type: 'error',
                message: `${errors[key]?.itemName} in ${errors[key]?.storeName} - ${errors[key]?.message}`,
            });
            return;
        }
    }

    setConfirmationModal({
        isOpen: true,
        heading: heading,
        message: message,
        handleCloseConfirmation: handleCloseConfirmation,
        handleConfirmSave: handleConfirmSave,
    });
};